<template>
  <div class="s-vam">
    <span class="u-dimmed u-font-sm">{{ $t('playback_rate') }}:&nbsp;</span>
    <button class="button button_xs rate-switcher" v-on:click="updateRate" :title="$t('change_playback_rate')">
      {{ rate }}x
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      rate: {
        type: Number,
        default: 1.0
      }
    },

    methods: {
      updateRate () {
        this.$emit('rateupdate',
          this.rate < 1.5 ? this.rate + 0.25 : 1
        )
      }
    }
  }
</script>

<style>
  .rate-switcher {
    width: 3.25em;
    padding-left: 0;
    padding-right: 0;
    font-weight: bold;
    background-color: rgba(255,255,255, 0.16);
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaybackRate.vue